import { render, staticRenderFns } from "./CertificateDrawer.vue?vue&type=template&id=0d5a01e5&scoped=true"
import script from "./CertificateDrawer.vue?vue&type=script&lang=ts"
export * from "./CertificateDrawer.vue?vue&type=script&lang=ts"
import style0 from "./CertificateDrawer.vue?vue&type=style&index=0&id=0d5a01e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a01e5",
  null
  
)

export default component.exports